import { Button, Modal } from 'antd';
import { MdOutlineLogout } from 'react-icons/md';
import '../../styles/CustomModal.css';

const LogoutModal = ({ open, onClose, onLogout, loading = false }) => {
    const logoutIcon = (
        <div className="logout_modal_icon_badge">
            <MdOutlineLogout />
        </div>
    );

    const footer = (
        <>
            <Button onClick={onClose} disabled={loading}>
                Cancel
            </Button>
            <Button
                type="primary"
                onClick={onLogout}
                loading={loading}
                disabled={loading}
                className="logout_modal_confirm_btn"
            >
                Log Out
            </Button>
        </>
    );

    return (
        <Modal
            footer={footer}
            title={logoutIcon}
            mask={{ enabled: true, blur: true }}
            open={open}
            onOk={onClose}
            onCancel={onClose}
            centered
            className="status_action_modal logout_action_modal"
        >
            <div className="my-4 status_modal_body_content">
                <h3 className="status_modal_title">Are you sure you want to log out?</h3>
                <p className="status_modal_desc">
                    Logging out will end your current session. Make sure all unsaved work is saved before continuing.
                </p>
            </div>
        </Modal>
    );
};

export default LogoutModal;